import { render, staticRenderFns } from "./CobranzaView.vue?vue&type=template&id=cef55eb2&scoped=true"
import script from "./CobranzaView.vue?vue&type=script&lang=js"
export * from "./CobranzaView.vue?vue&type=script&lang=js"
import style0 from "./CobranzaView.vue?vue&type=style&index=0&id=cef55eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef55eb2",
  null
  
)

export default component.exports